/**
 * TermTooltip — inline hover/focus tooltip for domain terms.
 * Keyboard-accessible: tab to the term, tooltip appears on focus (WCAG 2.1 §1.4.13).
 */
"use client";

import { TERM_GLOSSARY } from "@petci/fixtures";
import { Tooltip } from "@/components/Tooltip";

export function TermTooltip({
  term,
  children,
}: {
  term: string;
  children: React.ReactNode;
}) {
  const entry = TERM_GLOSSARY[term];
  if (!entry) return <>{children}</>;

  return (
    <Tooltip
      width="w-56"
      content={
        <>
          <span className="block font-semibold text-white mb-1">{term}</span>
          <span className="block text-neutral-300 leading-relaxed">{entry.short}</span>
          {entry.benchmark && (
            <span className="block mt-1.5 text-brand-primary/90 font-medium">
              {entry.benchmark}
            </span>
          )}
        </>
      }
    >
      <span className="cursor-help underline decoration-dotted decoration-neutral-400 underline-offset-2 focus:outline-none focus:decoration-brand-primary">
        {children}
      </span>
    </Tooltip>
  );
}
